import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ErrorService } from '../services/error.service';
import { markApiErrorHandled } from '../transport/api-error';
import { API_PREFIX } from '../transport/endpoints';
import { ToasterService } from '../modules/toaster/toaster.service';
import { AuthService } from './auth.service';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const errorService = inject(ErrorService);
  const toasterService = inject(ToasterService);
  const token = authService.token;
  const authenticatedRequest = shouldAttachApiAuth(request.url)
    ? request.clone({
      setHeaders: {
        Accept: 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
    })
    : request;

  return next(authenticatedRequest).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 403) {
        const apiError = markApiErrorHandled(errorService.normalize(error));

        toasterService.error(apiError.message);

        return throwError(() => apiError);
      }

      return throwError(() => error);
    }),
  );
};

function shouldAttachApiAuth(url: string): boolean {
  if (url === API_PREFIX || url.startsWith(`${API_PREFIX}/`)) {
    return true;
  }

  if (!/^https?:\/\//.test(url)) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);

    return parsedUrl.origin === window.location.origin
      && (parsedUrl.pathname === API_PREFIX || parsedUrl.pathname.startsWith(`${API_PREFIX}/`));
  } catch {
    return false;
  }
}
